import React from 'react';
import HowToGuide from '../components/HowToGuide';
import Navbar from '../components/Navbar';

function HowToPage() {
  return (
    <div className="how-to-page">
      <Navbar />
      <div className="container mx-auto px-4 py-8 mt-20">
        <HowToGuide />
      </div>
    </div>
  );
}

export default HowToPage;